import { toItem } from '../mappers/item';
export function parseItems(res) {
  const {
    nextPageToken,
    mediaItems
  } = res.data;
  const paging = {
    cursor: nextPageToken || null
  };
  return {
    data: (mediaItems || []).map(toItem),
    paging
  };
}